'use client'
import type { DefaultCellComponentProps } from 'payload'

import type { Ordine } from '@/payload-types'

import './ordini.scss'

/** List cell for `email`: billing name, email and whether the customer has an account. */
export const CellaCliente: React.FC<DefaultCellComponentProps> = ({ cellData, rowData }) => {
  const ordine = rowData as Partial<Ordine>
  const f = ordine.fatturazione
  const nome = f?.ragioneSociale || [f?.nome, f?.cognome].filter(Boolean).join(' ')
  return (
    <span className="cella-cliente">
      {nome && <strong>{nome}</strong>}
      <span>{String(cellData ?? '')}</span>
      <small>{ordine.cliente ? 'Cliente registrato' : 'Ospite'}</small>
    </span>
  )
}
